class IrUtils {
    static detailRowTypeName: string = "Detail";
    static totalRowTypeName: string = "Total";
    static subTotalRowTypeName: string = "Subtotal";
    static subTotalStartRowTypeName: string = "SubtotalStart";

    private static _loadPanel: DevExpress.ui.dxLoadPanel;

    private static get loadPanel() {
        if (!IrUtils._loadPanel) {
            let $div = $('<div>');
            $div.appendTo("body");

            IrUtils._loadPanel = $div.dxLoadPanel({
                message: "Loading...",
                visible: false,
                showIndicator: true,
                showPane: true,
                shading: true,
                shadingColor: "rgb(0 0 141 / 10%)",
                hideOnOutsideClick: false,
                indicatorSrc: urlConfigs.siteRoot + "Content/irng_logo_simple.svg",
                wrapperAttr: {
                    id: "irLoadPanel",
                },
                onShown(e) {
                    $("#irLoadPanel .dx-loadindicator-image").addClass("animate__animated animate__lightSpeedInLeft animate__infinite animate__faster");
                },
                onHidden(e) {
                    $("#irLoadPanel .dx-loadindicator-image").removeClass("animate__animated animate__lightSpeedInLeft animate__infinite animate__faster");
                },
            }).dxLoadPanel('instance');
        }
        return IrUtils._loadPanel;
    }

    static showLoadPanel(message?: string) {
        IrUtils.loadPanel.option("message", message ?? "Loading...");
        IrUtils.loadPanel.show();
    }

    static hideLoadPanel() {
        IrUtils.loadPanel.hide();
    }
}